import styled from "@emotion/styled";

import logo from "src/assets/images/new_logo_white.svg";
import { i18n, mediaQuery, openContactModal } from "src/common";
import config from "src/config";
import { colors, header, headerData, headerWidget } from "src/theme";
import { Flex } from "../grid";
import { Text } from "../typography";
import { HeaderWidget } from "./headerWidget.layout";
import { HeaderData } from './headerData.layout';
import { ProgressBar } from "../other";
import { useLocation } from "react-router-dom";
import { getStepConfig } from "src/pages/app";
// import { HeaderWidgetGiveaway } from "./headerWidget.layout";

const HeaderStyle = styled.div<{ expanded: boolean | null }>(({ expanded }) => ({
  backgroundColor: colors.primary,
  height: `${header.mobileHeight}px`,
  position: 'fixed',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: 100,

  [mediaQuery('laptopL')]: {
    height: `${header.height + headerData(expanded).height}px`,
  },
  transition: 'height 0.3s ease-out',
}))

const TextStyle = styled(Text)({
  color: colors.white
})

const LinkStyle = styled.a({
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.6
  },
})

const LogoStyle = styled.img({
  height: '24px'
})

const ContainerStyle = styled(Flex)({
  height: `${header.mobileHeight - headerWidget.mobileHeight}px`,
  padding: '24px',

  [mediaQuery('laptopL')]: {
    height: `${header.height - headerWidget.height}px`,
  },
});

interface HeaderProps {
  expanded: boolean | null;
  onExpandedChange: (expanded: boolean | null) => void;
}

export const Header = (props: HeaderProps) => {
  const { expanded, onExpandedChange } = props;
  const bannerMessage: string = '';

  const navigateToHome = () => {
    window.location.href = config.REACT_APP_KOMPARE_HOME!;
  };

  const { pathname } = useLocation();
  const stepConfig = getStepConfig(pathname);
  console.log(stepConfig)
  if (!stepConfig) return;

  return (
    <HeaderStyle expanded={expanded}>
      {/* <WidgetStyle /> */}
      <ContainerStyle justify='space-between' align='center' gap={8}>
        <LinkStyle onClick={navigateToHome}><LogoStyle src={logo} alt="" /></LinkStyle>
          <LinkStyle onClick={() => openContactModal()}>
            <TextStyle type="base" bold>{i18n.t('layout.header.requestAgent')}</TextStyle>
          </LinkStyle>
      </ContainerStyle>
      <HeaderData expanded={expanded} handleStyleExpansion={onExpandedChange} />
      <HeaderWidget message={bannerMessage} />
      { stepConfig.step && <ProgressBar currentStep={stepConfig.step} totalSteps={stepConfig.totalSteps}  />}
    </HeaderStyle>
  )
};
